"use client";

import Link from "next/link";
import { MEMBERS } from "./data";
import { Pfp } from "./Pfp";
import { SectionLabel } from "./ui";

/* /app/ — the home dashboard: stats up top, quick links below */

const STATS = [
  { label: "Unread messages", value: "12" },
  { label: "Members online", value: "5/10" },
  { label: "Notes", value: "10" },
  { label: "Servers", value: "1" },
];

const JUMP = [
  { title: "The GC", sub: "10 members", src: "/gc.jpg", href: "/app/g/1034567890123456789" },
  { title: "Milk", sub: "milk#0001", src: "/dm1.jpg", href: "/app/d/1012345678901234567" },
  { title: "Notes", sub: "10 notes", src: "/notes.jpg", href: "/app/n/1045678901234567890" },
];

export function DashboardView({ mobile = false }: { mobile?: boolean }) {
  return (
    <section
      className={`flex min-w-0 flex-1 flex-col overflow-y-auto bg-ink scroll-dark ${
        mobile ? "" : "mt-[var(--matte-t)]"
      }`}
    >
      <header className="shrink-0 border-b border-line px-5 py-3.5">
        <h1 className="text-heading font-bold tracking-tight text-fg">
          Dashboard
        </h1>
        <p className="text-micro text-fg-faint">Welcome back.</p>
      </header>

      <div className="grid grid-cols-2 gap-3 p-5 sm:grid-cols-4">
        {STATS.map((s) => (
          <div
            key={s.label}
            className="rounded-xl bg-panel/60 p-4 ring-1 ring-line"
          >
            <p className="text-xl font-bold tracking-tight text-fg tabular-nums">
              {s.value}
            </p>
            <p className="mt-0.5 text-micro text-fg-faint">{s.label}</p>
          </div>
        ))}
      </div>

      <SectionLabel>Jump back in</SectionLabel>
      <ul className="space-y-0.5 px-2.5 pb-5">
        {JUMP.map((j) => (
          <li key={j.href}>
            <Link
              href={j.href}
              className="flex items-center gap-2.5 rounded-lg px-2.5 py-2 transition hover:bg-raise"
            >
              <span
                aria-hidden
                className="h-9 w-9 shrink-0 rounded-lg bg-panel-hi bg-cover bg-center"
                style={{ backgroundImage: `url(${j.src})` }}
              />
              <span className="min-w-0">
                <span className="block truncate text-note font-semibold text-fg">
                  {j.title}
                </span>
                <span className="block truncate text-micro text-fg-faint">
                  {j.sub}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <SectionLabel>Friends online</SectionLabel>
      <ul className="space-y-0.5 px-2.5 pb-6">
        {MEMBERS.filter((m) => m.status === "online").map((m) => (
          <li
            key={m.id}
            className="flex items-center gap-2.5 rounded-lg px-2.5 py-1.5"
          >
            <Pfp src={m.src} status={m.status} size={28} rounded="rounded-lg" />
            <span className="truncate text-note font-medium text-fg-dim">
              {m.name}
            </span>
            <span className="truncate text-micro text-fg-faint">
              {m.id}#{m.tag}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
